export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・改善計画に記載する内容は{toCompanyName}に表示されます。\n・添付ファイルはファイル名のみ{toCompanyName}に表示され、ファイルの中身は共有されません。',
    },
    chat: {
      card_title: 'メッセージ',
      input_area_description: '改善計画に関して{toCompanyName}にメッセージを送ることができます。',
      send_confirm: {
        modal_title: 'メッセージを送信する',
        confirm_text: 'このメッセージを送信してよろしいですか？',
        confirm_text_near_by_check_box: 'メッセージを確認した。',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        toast_text: 'メッセージを送信しました。',
      },
      delete_confirm: {
        modal_title: 'メッセージ削除確認',
        confirm_text: 'このメッセージを削除してよろしいですか？',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: '送受信履歴',
        send_status: {
          success: '送信済',
          failure: '送信失敗',
        },
      },
    },
  },
}
